module.exports = __webpack_public_path__ + "static/elle-hallal-avatar-b94b3b5b3bef71d3be472bc962266e18.png";